
export const CategoriesSection = () => {
  return (
    <section
      data-w-id="0085a129-38f3-1129-89e6-562bb0aa96b6"
      className="bg-wrap-section"
    >
      <div className="creatives">
        <div
          data-w-id="2fd194e4-cea0-a6df-27d7-30799062408d"
          style={{ opacity: 1 }}
          className="con-right-painting"
        >
          <div className="slider-image-painting">
            <img
              src="/images/paint_1.svg"
              loading="lazy"
              alt=""
              className="painting-image"
            />
          </div>
          <div className="slider-table-painting">
            <img
              src="/images/user-polls-preview.webp"
              loading="lazy"
              sizes="(max-width: 1259px) 100vw, 1259px"
              srcSet="/images/user-polls-preview-p-500.webp 500w, /images/user-polls-preview-p-800.webp 800w, /images/user-polls-preview-p-1080.webp 1080w, /images/user-polls-preview.webp 1259w"
              alt=""
              className="image-3"
            />
          </div>
        </div>
        <div className="con-left top">
          <div className="lisitng-div mg-topspo">
            <h3
              data-w-id="0085a129-38f3-1129-89e6-562bb0aa96ba"
              style={{ opacity: 1 }}
              className="lisitng-highlight"
            >
              We’ve got plans. You just show up.
            </h3>
            <h2
              data-w-id="0085a129-38f3-1129-89e6-562bb0aa96bc"
              style={{ opacity: 1 }}
              className="listing-title"
            >
              Creative and artistic
            </h2>
            <div
              data-w-id="0085a129-38f3-1129-89e6-562bb0aa96be"
              style={{ opacity: 1 }}
              className="home-desc"
            >
              <p className="listing-des">
                Unleash your inner artist with hands-on workshops, inspiring
                classes, andcreative experiences that spark joy. From pottery and
                painting to photographyand DIY crafts.
              </p>
            </div>
            <a
              data-w-id="0085a129-38f3-1129-89e6-562bb0aa96c1"
              style={{ opacity: 1 }}
              href="/listing/6914277d2fb79c91edafbd32"
              className="lisitng-btn w-inline-block"
            >
              <div className="text-block">Explore</div>
            </a>
          </div>
        </div>
      </div>
      <div className="art">
        <div className="con-left mg-top spec">
          <div className="lisitng-div">
            <h3
              data-w-id="691d151b-53ce-d2c0-807c-b2acdca1b5ed"
              style={{ opacity: 1 }}
              className="lisitng-highlight"
            >
              We’ve got plans. You just show up.
            </h3>
            <h2
              data-w-id="691d151b-53ce-d2c0-807c-b2acdca1b5ef"
              style={{ opacity: 1 }}
              className="listing-title"
            >
              Performing arts
            </h2>
            <div
              data-w-id="691d151b-53ce-d2c0-807c-b2acdca1b5f1"
              style={{ opacity: 1 }}
              className="home-desc"
            >
              <p className="listing-des">
                No stage too big, no dream too bold. Step into the spotlight and
                let your passionshine
              </p>
            </div>
            <a
              data-w-id="691d151b-53ce-d2c0-807c-b2acdca1b5f4"
              style={{ opacity: 1 }}
              href="/listing/691427892fb79c91edafbd34"
              className="lisitng-btn w-inline-block"
            >
              <div className="text-block">Explore</div>
            </a>
          </div>
        </div>
        <div
          data-w-id="edfba084-fde1-8d42-8920-ce05a43f6bf5"
          style={{ opacity: 1 }}
          className="con-right-art"
        >
          <div className="slider-image-arts">
            <img
              src="/images/perfomance.svg"
              loading="lazy"
              alt=""
              className="trumpent-image"
            />
          </div>
          <div className="slider-table-arts">
            <img
              src="/images/user-polls-preview.webp"
              loading="lazy"
              sizes="(max-width: 1259px) 100vw, 1259px"
              srcSet="/images/user-polls-preview-p-500.webp 500w, /images/user-polls-preview-p-800.webp 800w, /images/user-polls-preview-p-1080.webp 1080w, /images/user-polls-preview.webp 1259w"
              alt=""
              className="image-3"
            />
          </div>
        </div>
      </div>
      <div className="sport">
        <div
          data-w-id="47c69c2a-48fe-71d5-acd7-d3ba6ed6987f"
          style={{ opacity: 1 }}
          className="con-right-painting"
        >
          <div className="slider-image-painting _100">
            <img
              src="/images/sport-icon.svg"
              loading="lazy"
              alt=""
              className="painting-image"
            />
          </div>
          <div className="slider-table-painting">
            <img
              src="/images/bg-white.svg"
              loading="lazy"
              alt=""
              className="image-3"
            />
          </div>
        </div>
        <div className="con-left top">
          <div className="lisitng-div mg-topspo">
            <h3
              data-w-id="47c69c2a-48fe-71d5-acd7-d3ba6ed69886"
              style={{ opacity: 1 }}
              className="lisitng-highlight"
            >
              We’ve got plans. You just show up.
            </h3>
            <h2
              data-w-id="47c69c2a-48fe-71d5-acd7-d3ba6ed69888"
              style={{ opacity: 1 }}
              className="listing-title"
            >
              sports
            </h2>
            <div
              data-w-id="47c69c2a-48fe-71d5-acd7-d3ba6ed6988a"
              style={{ opacity: 1 }}
              className="home-desc"
            >
              <p className="listing-des">
                Get your game on with activities that keep you moving and having
                fun, whetheryou're a seasoned player or just starting out, there's
                a match for everyone here.
              </p>
            </div>
            <a
              data-w-id="47c69c2a-48fe-71d5-acd7-d3ba6ed6988d"
              style={{ opacity: 1 }}
              href="/listing/691427962fb79c91edafbd36"
              className="lisitng-btn w-inline-block"
            >
              <div className="text-block">Explore</div>
            </a>
          </div>
        </div>
      </div>
      <div className="puzzles">
        <div className="con-left mg-top">
          <div className="lisitng-div mg-topganes">
            <h3
              data-w-id="9d54dbe2-9f30-53c7-809f-0d117ac9ce11"
              style={{ opacity: 1 }}
              className="lisitng-highlight"
            >
              We’ve got plans. You just show up.
            </h3>
            <h2
              data-w-id="9d54dbe2-9f30-53c7-809f-0d117ac9ce13"
              style={{ opacity: 1 }}
              className="listing-title"
            >
              <strong className="bold-text">Games and puzzles</strong>
            </h2>
            <div
              data-w-id="9d54dbe2-9f30-53c7-809f-0d117ac9ce15"
              style={{ opacity: 1 }}
              className="home-desc"
            >
              <p className="listing-des">
                Sharpen your mind and bring on the laughs with activities that
                challenge,entertain, and connect. It's playtime for thinkers,
                teams, and anyone up for a littlefriendly competition.
              </p>
            </div>
            <a
              data-w-id="9d54dbe2-9f30-53c7-809f-0d117ac9ce18"
              style={{ opacity: 1 }}
              href="/listing/691427e02fb79c91edafbd46"
              className="lisitng-btn w-inline-block"
            >
              <div className="text-block">Explore</div>
            </a>
          </div>
        </div>
        <div
          data-w-id="9d54dbe2-9f30-53c7-809f-0d117ac9ce1b"
          style={{ opacity: 1 }}
          className="con-right-art"
        >
          <div className="slider-image-puzzle">
            <img
              src="/images/puzzle.svg"
              loading="lazy"
              alt=""
              className="puzzle-image"
            />
          </div>
          <div className="slider-table-arts">
            <img
              src="/images/user-polls-preview.webp"
              loading="lazy"
              sizes="(max-width: 1259px) 100vw, 1259px"
              srcSet="/images/user-polls-preview-p-500.webp 500w, /images/user-polls-preview-p-800.webp 800w, /images/user-polls-preview-p-1080.webp 1080w, /images/user-polls-preview.webp 1259w"
              alt=""
              className="image-3"
            />
          </div>
        </div>
      </div>
      <div className="nature">
        <div
          data-w-id="255078c1-0db5-fce8-10e4-a264b42e7fe1"
          style={{ opacity: 1 }}
          className="con-right-painting"
        >
          <div className="slider-image-painting">
            <img
              src="/images/nature-camp.svg"
              loading="lazy"
              alt=""
              className="painting-image"
            />
          </div>
          <div className="slider-table-painting">
            <img
              src="/images/user-polls-preview.webp"
              loading="lazy"
              sizes="(max-width: 1259px) 100vw, 1259px"
              srcSet="/images/user-polls-preview-p-500.webp 500w, /images/user-polls-preview-p-800.webp 800w, /images/user-polls-preview-p-1080.webp 1080w, /images/user-polls-preview.webp 1259w"
              alt=""
              className="image-3"
            />
          </div>
        </div>
        <div className="con-left top">
          <div className="lisitng-div mg-topspo">
            <h3
              data-w-id="255078c1-0db5-fce8-10e4-a264b42e7fe8"
              style={{ opacity: 1 }}
              className="lisitng-highlight"
            >
              We’ve got plans. You just show up.
            </h3>
            <h2
              data-w-id="255078c1-0db5-fce8-10e4-a264b42e7fea"
              style={{ opacity: 1 }}
              className="listing-title"
            >
              <strong className="bold-text-2">
                Outdoor and nature based activities
              </strong>
            </h2>
            <div
              data-w-id="255078c1-0db5-fce8-10e4-a264b42e7fec"
              style={{ opacity: 1 }}
              className="home-desc"
            >
              <p className="listing-des">
                Step outside and soak it all in — fresh air, wide-open spaces, and
                unforgettableexperiences. These activities help you reconnect with
                the world (and yourself) beyondthe screen.
              </p>
            </div>
            <a
              data-w-id="255078c1-0db5-fce8-10e4-a264b42e7fef"
              style={{ opacity: 1 }}
              href="/listing/691427e92fb79c91edafbd48"
              className="lisitng-btn w-inline-block"
            >
              <div className="text-block">Explore</div>
            </a>
          </div>
        </div>
      </div>
      <div className="cullinary">
        <div className="con-left mg-top">
          <div className="lisitng-div mg-topganes">
            <h3
              data-w-id="6fdc088a-1122-7e37-e46f-d53b28e4446c"
              style={{ opacity: 1 }}
              className="lisitng-highlight"
            >
              We’ve got plans. You just show up.
            </h3>
            <h2
              data-w-id="6fdc088a-1122-7e37-e46f-d53b28e4446e"
              style={{ opacity: 1 }}
              className="listing-title"
            >
              <strong className="bold-text-3">Culinary activities</strong>
            </h2>
            <div
              data-w-id="6fdc088a-1122-7e37-e46f-d53b28e44471"
              style={{ opacity: 1 }}
              className="home-desc"
            >
              <p className="listing-des">
                Roll up your sleeves and get cooking — or tasting! Come hungry,
                leave inspired.
              </p>
            </div>
            <a
              data-w-id="6fdc088a-1122-7e37-e46f-d53b28e44474"
              style={{ opacity: 1 }}
              href="/listing/691427b82fb79c91edafbd3c"
              className="lisitng-btn w-inline-block"
            >
              <div className="text-block">Explore</div>
            </a>
          </div>
        </div>
        <div
          data-w-id="6fdc088a-1122-7e37-e46f-d53b28e44477"
          style={{ opacity: 1 }}
          className="con-right-art"
        >
          <div className="slider-image-cook _80">
            <img
              src="/images/cook_1.svg"
              loading="lazy"
              alt=""
              className="puzzle-image"
            />
          </div>
          <div className="slider-table-arts">
            <img
              src="/images/user-polls-preview.webp"
              loading="lazy"
              sizes="(max-width: 1259px) 100vw, 1259px"
              srcSet="/images/user-polls-preview-p-500.webp 500w, /images/user-polls-preview-p-800.webp 800w, /images/user-polls-preview-p-1080.webp 1080w, /images/user-polls-preview.webp 1259w"
              alt=""
              className="image-3"
            />
          </div>
        </div>
      </div>
      <div className="learning">
        <div
          data-w-id="ba28cc87-aebb-daa7-a5a3-10909ef9bc88"
          style={{ opacity: 1 }}
          className="con-right-learn"
        >
          <div className="slider-image-learn">
            <img
              src="/images/learn.svg"
              loading="lazy"
              alt=""
              className="image-2"
            />
          </div>
          <div className="slider-table">
            <img
              src="/images/user-polls-preview.webp"
              loading="lazy"
              sizes="(max-width: 1259px) 100vw, 1259px"
              srcSet="/images/user-polls-preview-p-500.webp 500w, /images/user-polls-preview-p-800.webp 800w, /images/user-polls-preview-p-1080.webp 1080w, /images/user-polls-preview.webp 1259w"
              alt=""
              className="image-3"
            />
          </div>
        </div>
        <div className="con-left bottom">
          <div className="lisitng-div mg-topspo">
            <h3
              data-w-id="ba28cc87-aebb-daa7-a5a3-10909ef9bc8f"
              style={{ opacity: 1 }}
              className="lisitng-highlight"
            >
              We’ve got plans. You just show up.
            </h3>
            <h2
              data-w-id="ba28cc87-aebb-daa7-a5a3-10909ef9bc91"
              style={{ opacity: 1 }}
              className="listing-title"
            >
              <strong className="bold-text-4">Intellectual and learning</strong>
            </h2>
            <div
              data-w-id="ba28cc87-aebb-daa7-a5a3-10909ef9bc93"
              style={{ opacity: 1 }}
              className="home-desc"
            >
              <p className="listing-des">
                Feed your curiosity and explore something new. From
                thought-provoking talks andlanguage classes to hands-on workshops
                and deep dives into fascinating topics —these activities are all
                about growing your mind in fun, inspiring ways.
              </p>
            </div>
            <a
              data-w-id="ba28cc87-aebb-daa7-a5a3-10909ef9bc96"
              style={{ opacity: 1 }}
              href="/listing/6914280a2fb79c91edafbd4c"
              className="lisitng-btn w-inline-block"
            >
              <div className="text-block">Explore</div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
